import React from 'react';
import { Toaster } from 'react-hot-toast';
import { GameComponent } from './components/GameComponent';
import { AuthComponent } from './components/AuthComponent';
// Initialize wallet setup tools for browser console access
import './App.css';

export function App() {
  const [user, setUser] = React.useState<any>(null);

  const handleUserChange = (userData: any) => {
    setUser(userData);
  };

  return (
    <div className="app" suppressHydrationWarning={true}>
      <header className="app-header">
        <div className="container">
          <h1 className="app-title">Kingsomni</h1>
          <div className="auth-section" suppressHydrationWarning={true}>
            <AuthComponent onUserChange={handleUserChange} />
          </div>
        </div>
      </header>

      <main className="app-main">
        <div className="container">
          <GameComponent user={user} />
        </div>
      </main>

      <footer className="app-footer">
        <div className="container">
          <p className="footer-text">
            Made by{" "}
            <a
              href="https://github.com/Kingsomni"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kingsomni Team
            </a>{" "}
            💙 • Powered by Somnia Reactivity
          </p>
          <div className="footer-links">
            <a
              href="https://kingsomni.vercel.app/leaderboard"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Public Leaderboard
            </a>
          </div>
        </div>
      </footer>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#13243d",
            color: "#ffffff",
            border: "1px solid #2596be",
          },
          success: {
            iconTheme: {
              primary: "#4ade80",
              secondary: "#ffffff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#ffffff",
            },
          },
        }}
      />
    </div>
  );
}
